import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { getWeekNumber } from '../../../../utils/Common';
import ContenedorLabor from './ContenedorLabor';
const GeneradorActividadesV2 = (p) => {
    const [loader, setloader] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    const [rendimientos, setrendimientos] = useState([]);
    const [semanas, setsemanas] = useState([]);
    const [formularios, setformularios] = useState({ "areas": [], "labores": [], "um": [], "fecha_ancla": [], "inventario": [] });
    const [rendimientosFiltros, setrendimientosFiltros] = useState({ rendimiento_id: 0, semana: "2417", "area": 0, "labor": 0, "um": 0, "fecha_ancla": "", "inventario": "" });
    const [actividades, setactividades] = useState([]);
    const [selecciones, setselecciones] = useState({});
    const [week, setweek] = useState("2417");
    var counter = 0;


    useEffect(() => {
        let ww = getWeekNumber();
        let semana = ww[1] < 10 ? `0${ww[1]}` : ww[1];
        let anio = (`${ww[0] - 2000}${semana}`);

        setrendimientosFiltros({ ...rendimientosFiltros, semana: anio });
        getRendimientos(true)
        generadorSemanas();
        setweek(anio);
    }, []);

    const changeFilter = (event) => {
        let { name, value } = event.target;
        setrendimientosFiltros({ ...rendimientosFiltros, [name]: value });
        getRendimientos(false, { ...rendimientosFiltros, [name]: value });
        generarActividades({ ...rendimientosFiltros, [name]: value });
    }

    const getRendimientos = async (opciones = false, filtros = { ...rendimientosFiltros }) => {
        filtros.opciones = opciones;
        setselecciones({});
        let resp = await Post('nomina_externa/rendimientos', filtros);
        if (!resp.estatus) {
            showDialog('Error', resp.msj);
            return;
        }

        setrendimientos(resp.data);
        if (resp.opciones) setformularios(resp.opciones.data);
    }

    const showDialog = (title = "", body = "", tipo = "error",) => {
        setdialog({
            show: true,
            tipo: tipo,
            title: title,
            body: body,
            size: 'm',
            funct: () => { setdialog({ show: false }) }
        });
    }

    const generadorSemanas = () => {
        let semanas = [];
        let date = new Date()
        let year = date.getFullYear() - 2001;
        for (let i = 0; i < 3; i++) {
            for (let j = 1; j < 53; j++) {
                let semana = `${j < 10 ? `0${j}` : j}`
                semanas.push(`${year}${semana}`);
            }
            year++;
        }
        setsemanas(semanas);
    }

    const generarActividades = async (filtros = { ...rendimientosFiltros }) => {
        if (filtros.semana == "" || filtros.rendimiento_id < 1) {
            setactividades([]);
            return;
        }
        setloader(true);
        let resp = await Post('nomina_externa/generar', filtros);
        setloader(false);
        if (!resp.estatus) {
            showDialog('Error', resp.msj);
            return;
        }
        setactividades(resp.data);
        setTimeout(() => {
            let elemento = document.getElementById('contenedor_actividad_0');
            if (elemento) elemento.scrollIntoView({ behavior: "smooth" });
        }, 200);
    }

    const changeChild = (data) => {
        let { index, value } = data;
        let newActividades = [...actividades];
        newActividades[index] = value;
        setactividades(newActividades);
    }

    const seleccionarRegistro = (index) => {
        let sels = { ...selecciones };
        if (sels[index]) delete sels[index];
        else sels[index] = true;
        setselecciones(sels);
    }

    const gurdarSelecciones = async () => {
        let keys = Object.keys(selecciones);
        let labs = keys.map((k) => actividades[k]);
        if (labs.length < 1) return;
        let resp = await Post('nomina_externa/crear_actividades', { labores: labs });
        console.log(`Respuesta: `, resp);
        showDialog(resp.estatus ? 'Acción exitosa' : 'Error', resp.msj, resp.estatus ? 'sucess' : 'error');
        if (resp.estatus) {
            setselecciones({});
            await generarActividades();
        }


    }

    return (
        <>
            <div className='w-100 h-100 m-0 p-2 dosis' >
                <div className='row justify-content-evenly w-100 m-0 p-1 bg-white4 blur-m round-m shadow-sm' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                    <div className='form-group bw-300 m-1'>
                        <label className='text-bold w-100 text-s hide-600'>Actividades de nómina</label>
                        <select className='form-control form-control-sm border shadow border-warning'
                            onChange={changeFilter}
                            value={rendimientosFiltros.rendimiento_id}
                            name='rendimiento_id'
                        >
                            <option value={0} >Seleccione una actividad</option>
                            {rendimientos.map((r) => {
                                return (<option key={counter++} value={r.id}>{r.area} °°° {r.labor}</option>)
                            })}
                        </select>
                    </div>

                    <div className='form-group bw-150 m-1'>
                        <label className='text-bold w-100 text-s hide-600'>Semana</label>
                        <select className='form-control form-control-sm border shadow'
                            name='semana'
                            value={rendimientosFiltros.semana}
                            onChange={changeFilter}>
                            {semanas.map((s) => <option key={counter++} className={`${+s === +week ? 'text-bold text-white bg-dark ' : ''}`} value={s}>
                                {s} {+s === +week ? ' Semana actual' : ''}
                            </option>)}
                        </select>
                    </div>

                    <div className='form-group bw-150 m-1 hide-800'>
                        <label className='text-bold w-100 text-s '>Filtro de área</label>
                        <select className='form-control form-control-sm border shadow'
                            name='area'
                            value={rendimientosFiltros.area}
                            onChange={changeFilter}>
                            <option value={0} >Todas las áreas</option>
                            {formularios.areas.map((a) => {
                                return (<option key={counter++} value={a.id}>{a.nombre}</option>)
                            })}
                        </select>
                    </div>

                    <div className='form-group bw-150 m-1 hide-800'>
                        <label className='text-bold w-100 text-s '>Filtro UM</label>
                        <select className='form-control form-control-sm border shadow'
                            value={rendimientosFiltros.um}
                            name='um'
                            onChange={changeFilter}>
                            <option value={0} >Todas las unidades de medida</option>
                            {formularios.um.map((a) => {
                                return (<option key={counter++} value={a.id}>{a.nombre}</option>)
                            })}
                        </select>
                    </div>

                    <div className='form-group bw-150 m-1 hide-800'>
                        <label className='text-bold w-100 text-s '>Filtro fecha asociada</label>
                        <select className='form-control form-control-sm border shadow'
                            value={rendimientosFiltros.fecha_ancla}
                            name='fecha_ancla'
                            onChange={changeFilter}>
                            <option value={0} >Todas los tipos de fecha</option>
                            {formularios.fecha_ancla.map((a) => {
                                return (<option key={counter++} value={a.fecha_ancla}>{a.fecha_ancla}</option>)
                            })}
                        </select>
                    </div>

                    <div className='form-group bw-150 m-1 hide-800'>
                        <label className='text-bold w-100 text-s '>Aplicación de inventario</label>
                        <select className='form-control form-control-sm border shadow'
                            value={rendimientosFiltros.inventario}
                            name='inventario'
                            onChange={changeFilter}>
                            <option value={0} >Todas los registros</option>
                            {formularios.inventario.map((a) => {
                                return (<option key={counter++} value={a.inventario}>{a.inventario}</option>)
                            })}
                        </select>
                    </div>

                    <div className='form-group bw-200 m-1 text-center contenedor'>
                        {Object.values(selecciones).length > 0 && <button
                            className='btn btn-dark scale-continue-05 border border-warning border-2 shadow '
                            onClick={gurdarSelecciones}
                        >GUARDAR {Object.values(selecciones).length} SELECCIONES</button>}
                    </div>
                    <div className='w-100 m-0 p-0'></div>

                </div>
                <div className='w-100 m-0 pt-0 pb-0 ps-2 pe-2 h-100'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        {actividades.map((a, index) => <React.Fragment key={counter++}>
                            <ContenedorLabor data={a} index={index} changeChild={changeChild} seleccionar={seleccionarRegistro} seleccionado={selecciones[index]} />
                        </React.Fragment>)}
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0, zIndex: 5 }}><div className='loader'></div></div>}
        </>
    )
}

export default GeneradorActividadesV2;